import {
  ApprovalStep,
  BulkApproveReportsRequest,
  GetApprovalReportsRequest,
} from '@ulysses-inc/harami_api_client'
import Redux from 'redux'
import actions, {
  addApprovalStep as addApprovalStepAction,
  deleteApproval as deleteApprovalAction,
  getApproval as getApprovalAction,
  resetApproval as resetApprovalAction,
} from './actions'
import { DeleteApprovalArg, GetApprovalReportsFilter } from './types'

const getApproval = (dispatch: Redux.Dispatch, approvalUUID: string) => {
  dispatch(getApprovalAction(approvalUUID))
}

const deleteApproval = (
  dispatch: Redux.Dispatch,
  arg: DeleteApprovalArg,
): void => {
  dispatch(deleteApprovalAction(arg))
}

const addApprovalStep = (
  dispatch: Redux.Dispatch,
  reportUUID: string,
  approvalUUID: string,
  currentStep: ApprovalStep,
  nextStep: ApprovalStep,
  url: string,
) => {
  dispatch(
    addApprovalStepAction(reportUUID, approvalUUID, currentStep, nextStep, url),
  )
}

const resetApproval = (dispatch: Redux.Dispatch) => {
  dispatch(resetApprovalAction())
}

const addApprovalReport = (
  dispatch: Redux.Dispatch,
  reportUUID: string,
  approvalFlowId: number,
  url: string,
) => {
  dispatch(actions.addApprovalReport(reportUUID, approvalFlowId, url))
}

const getApprovalReports = (
  dispatch: Redux.Dispatch,
  request: GetApprovalReportsRequest,
  filter?: GetApprovalReportsFilter,
) => {
  dispatch(actions.getApprovalReports(request, filter))
}

const changeApprovalReportsPage = (
  dispatch: Redux.Dispatch,
  page: number,
  pageSize: number,
  filter?: GetApprovalReportsFilter,
) => {
  dispatch(actions.changeApprovalReportsPage(page, pageSize, filter))
}

const changeApprovalReportsSize = (
  dispatch: Redux.Dispatch,
  pageSize: number,
  filter?: GetApprovalReportsFilter,
) => {
  dispatch(actions.changeApprovalReportsSize(pageSize, filter))
}

const updatePagination = (
  dispatch: Redux.Dispatch,
  limit: number,
  offset: number,
) => {
  dispatch(actions.updatePagination(limit, offset))
}

const updateFilter = (
  dispatch: Redux.Dispatch,
  filter: GetApprovalReportsFilter,
) => {
  dispatch(actions.updateFilter(filter))
}

const bulkApproveReports = (
  dispatch: Redux.Dispatch,
  bulkApproveReportsRequest: {
    request: BulkApproveReportsRequest
    filter?: GetApprovalReportsFilter
  },
) => {
  dispatch(
    actions.bulkApproveReports(
      bulkApproveReportsRequest.request,
      bulkApproveReportsRequest.filter,
    ),
  )
}

export default {
  getApproval,
  deleteApproval,
  addApprovalStep,
  resetApproval,
  addApprovalReport,
  getApprovalReports,
  changeApprovalReportsPage,
  changeApprovalReportsSize,
  updatePagination,
  updateFilter,
  bulkApproveReports,
}
